import { css } from 'react-strict-dom';

export const spacing = css.defineVars({
  unit: '16px',
});
